// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__13wyX","routes":"Layout_routes__G_FrN","alert":"Layout_alert__2ipzX"};